import { ReportData } from '../types/reportTypes';

// Cody Cline Direct Sales January 2026 Data
// IMPORTANT: Using 13% flat OH calculation (Contract Total × 0.13)
const jobData = [
  {
    jobInfo: "E-780: Allan & Marguerite Tomwigfield",
    leadSource: "Google Organic Search",
    trade: "Siding Replacement",
    contractTotal: 35093.00,
    grossMarginPct: 0.3667,
    grossProfit: 12868.60,
    commissionPercentage: 0,
    salesCommission: 0, // Will be calculated
    salesManagerFee: 0,
    companyOH: 35093.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-783: Pennrose Management Obery",
    leadSource: "Referral- Cody's network",
    trade: "Roofing",
    contractTotal: 1997.00,
    grossMarginPct: 0.4833,
    grossProfit: 965.15,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 1997.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-837: Aion Management Mariners Pointe PO 146633",
    leadSource: "Referral- Dominic's network",
    trade: "Miscellaneous",
    contractTotal: 2599.00,
    grossMarginPct: 0.5190,
    grossProfit: 1348.88,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 2599.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-808: Aion Management Mariners Pointe",
    leadSource: "Referral- Dominic's network",
    trade: "Siding",
    contractTotal: 1600.00,
    grossMarginPct: 0.3000,
    grossProfit: 480.00,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 1600.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-789: The Enclave At Ellicott Hills",
    leadSource: "Referral- Dominic's network",
    trade: "Miscellaneous",
    contractTotal: 899.00,
    grossMarginPct: 0.4438,
    grossProfit: 398.98,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 899.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-823: Tabor Lynch Project",
    leadSource: "Referral- Cody's network",
    trade: "Siding",
    contractTotal: 21387.00,
    grossMarginPct: 0.3000,
    grossProfit: 6416.10,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 21387.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-828: Pennrose Scarlett Oak",
    leadSource: "Unknown",
    trade: "Roofing",
    contractTotal: 7392.00,
    grossMarginPct: 0.6104,
    grossProfit: 4512.08,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 7392.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-827: Pennrose Orchard Ridge",
    leadSource: "Unknown",
    trade: "Roofing",
    contractTotal: 2464.00,
    grossMarginPct: 0.6104,
    grossProfit: 1504.03,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 2464.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-825: Pennrose Aspen Hill",
    leadSource: "Unknown",
    trade: "Roofing",
    contractTotal: 2464.00,
    grossMarginPct: 0.6104,
    grossProfit: 1504.03,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 2464.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-826: Pennrose Obery",
    leadSource: "Unknown",
    trade: "Roofing",
    contractTotal: 2464.00,
    grossMarginPct: 0.6104,
    grossProfit: 1504.03,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 2464.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-801: Aion Management Mariners Pointe PO 146605",
    leadSource: "Referral- Dominic's network",
    trade: "Miscellaneous",
    contractTotal: 2999.00,
    grossMarginPct: 0.3809,
    grossProfit: 1142.32,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 2999.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-835: The Enclave At Ellicott Hills",
    leadSource: "Referral- Dominic's network",
    trade: "Miscellaneous",
    contractTotal: 1200.00,
    grossMarginPct: 0.7917,
    grossProfit: 950.04,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 1200.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-799: Aion Management Mariners Pointe PO 146602",
    leadSource: "Referral- Dominic's network",
    trade: "Miscellaneous",
    contractTotal: 6500.00,
    grossMarginPct: 0.3759,
    grossProfit: 2443.35,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 6500.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-800: Aion Management Mariners Pointe PO 146603",
    leadSource: "Referral- Dominic's network",
    trade: "Miscellaneous",
    contractTotal: 2000.00,
    grossMarginPct: 0.3717,
    grossProfit: 743.40,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 2000.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-790: Ellicott Hills Condo 1",
    leadSource: "Referral- Dominic's network",
    trade: "Solar",
    contractTotal: 2181.00,
    grossMarginPct: 0.3260,
    grossProfit: 711.01,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 2181.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-782: Ben Schweitzer",
    leadSource: "Google Organic Search",
    trade: "Siding",
    contractTotal: 3750.00,
    grossMarginPct: 0.4993,
    grossProfit: 1872.38,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 3750.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-830: Pennrose Management Oaks at Liberty",
    leadSource: "Referral- Cody's network",
    trade: "Snow Removal",
    contractTotal: 2300.00,
    grossMarginPct: 0.5217,
    grossProfit: 1199.91,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 2300.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-781: Megan Sprayberry",
    leadSource: "Referral- Cody's network",
    trade: "Gutters",
    contractTotal: 4309.00,
    grossMarginPct: 0.4783,
    grossProfit: 2060.99,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 4309.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-832: Casey Maker",
    leadSource: "Referral- Cody's network",
    trade: "Siding, Gutters, Roofing",
    contractTotal: 22316.62,
    grossMarginPct: 0.6869,
    grossProfit: 15329.29,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 22316.62 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-798: Tovex LLC",
    leadSource: "Referral- Dominic's network",
    trade: "Roofing",
    contractTotal: 30245.45,
    grossMarginPct: 0.5519,
    grossProfit: 16692.46,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 30245.45 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-811: Nicole Valerio (815)",
    leadSource: "Referral- Dominic's network",
    trade: "Siding, Gutters, Roofing",
    contractTotal: 37768.16,
    grossMarginPct: 0.5864,
    grossProfit: 22147.25,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 37768.16 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-802: John Tabor Kasbekar project",
    leadSource: "Referral- Cody's network",
    trade: "Siding, Gutters, Roofing",
    contractTotal: 22826.67,
    grossMarginPct: 0.3000,
    grossProfit: 6848.00,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 22826.67 * 0.13, // 13% flat rate
    netProfit: 0
  }
];

// Apply Cody Cline calculation formula
// For Cody reports: Net Profit = Gross Profit - Company OH
// Sales Commission = Net Profit ÷ 2 (50% of Net Profit)
jobData.forEach(job => {
  job.netProfit = job.grossProfit - job.companyOH;
  job.salesCommission = job.netProfit / 2;
});

// Calculate totals
const totalContractValue = jobData.reduce((sum, job) => sum + job.contractTotal, 0);
const totalGrossProfit = jobData.reduce((sum, job) => sum + job.grossProfit, 0);
const totalCompanyOH = jobData.reduce((sum, job) => sum + job.companyOH, 0);
const totalNetProfit = jobData.reduce((sum, job) => sum + job.netProfit, 0);
const totalSalesCommissions = jobData.reduce((sum, job) => sum + job.salesCommission, 0);

// Aggregate sales by source
const salesBySourceMap = jobData.reduce((acc, job) => {
  const source = job.leadSource;
  if (!acc[source]) {
    acc[source] = {
      source,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[source].totalSales += job.contractTotal;
  acc[source].count += 1;
  acc[source].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { source: string; totalSales: number; count: number; grossProfit: number }>);

const salesBySource = Object.values(salesBySourceMap);

// Aggregate sales by trade
const salesByTradeMap = jobData.reduce((acc, job) => {
  const trade = job.trade;
  if (!acc[trade]) {
    acc[trade] = {
      trade,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[trade].totalSales += job.contractTotal;
  acc[trade].count += 1;
  acc[trade].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { trade: string; totalSales: number; count: number; grossProfit: number }>);

const salesByTrade = Object.values(salesByTradeMap);

export const codySalesJanuary2026Data: ReportData = {
  kpis: {
    adSpend: 0, // No ad spend for Cody direct sales
    totalSales: totalContractValue,
    grossProfit: totalGrossProfit,
    salesCommissions: totalSalesCommissions,
    managerFees: 0, // No manager fees in Cody structure
    companyOH: totalCompanyOH,
    netProfit: totalNetProfit,
    netProfitPercent: totalNetProfit / totalContractValue,
    grossProfitPercent: totalGrossProfit / totalContractValue
  },

  adSpendBySource: [
    { source: "Google Organic Search", spend: 0 },
    { source: "Referral- Cody's network", spend: 0 },
    { source: "Referral- Dominic's network", spend: 0 },
    { source: "Unknown", spend: 0 }
  ],

  salesBySource: salesBySource,

  salesByTrade: salesByTrade,

  jobData: jobData,

  period: {
    month: 1,
    year: 2026
  }
};
